import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useCallback } from 'react';

import {
  buildSearchSuccessUrl,
  PROPERTY_REPORT_MAP_FEATURE_KEY,
} from 'utils/searchSuccessRouting';

import type { SearchData } from '@ltvco/refresh-lib/v1';
import type { NavigateFunction } from 'react-router-dom';

/**
 * Returns a shared search-success handler that navigates to the correct
 * report route for any search type.
 */
export const useSearchSuccessRedirect = (
  navigate: NavigateFunction
): ((searchData: SearchData) => void) => {
  const isPropertyReportMapEnabled = useFeatureIsOn(
    PROPERTY_REPORT_MAP_FEATURE_KEY
  );

  return useCallback(
    (searchData: SearchData) => {
      navigate(buildSearchSuccessUrl(searchData, isPropertyReportMapEnabled));
    },
    [navigate, isPropertyReportMapEnabled]
  );
};
